<template>
	<validationProvider :rules="rules" v-slot="{ errors, valid }" immediate :name="$t('profile.background')">
		<p>
			<FormTitleText :titleText="$t('profile.background')" />
			<RequiredIcon v-if="rules && rules.includes('required')" />
		</p>
		<v-textarea
			v-model="inputedBackground"
			:placeholder="backgroundLabel"
			outlined
			background-color="white"
			counter
			:success="valid"
		></v-textarea>
		<FormErrorText :errorText="errors[0]" />
	</validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText'
import FormErrorText from '../Atoms/FormErrorText'
import mypageText from '@/data/mypage/mypageText'
import RequiredIcon from '../Atoms/RequiredIcon'

export default {
	name: 'BackgroundForm',
	components: {
		FormTitleText,
		FormErrorText,
		RequiredIcon
	},
	data: () => ({
		backgroundLabel: mypageText.backgroundLabel
	}),
	props: {
		value: {
			type: String,
			required: true
		},
		rules: {
			type: String,
			required: true
		}
	},
	mounted() {},
	computed: {
		inputedBackground: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {}
}
</script>

<style lang="scss" scoped></style>
